import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Cell, Grid } from '@phishtool/ui';
import { LegalDocumentContent, legalDocuments } from '@phishtool/legal-documents';
import { StyledLegalNav, StyledLegalNavListItem } from './styled';
import { Link, useLocation } from 'react-router-dom';
import { defaultContentGrid } from '~styles/shared';
import { Heading } from '~components/heading';
const LegalNavItem = ({ to, children }) => {
    const location = useLocation();
    return (_jsx(StyledLegalNavListItem, { isActive: location.pathname === to, children: _jsx(Link, { to: to, children: children }) }));
};
const publicLegalDocuments = Object.entries(legalDocuments).filter(([, { isPublicPage }]) => isPublicPage);
const Legal = ({ id }) => {
    const { title, content } = legalDocuments[id];
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { children: _jsx(Cell, { start: defaultContentGrid.start, end: defaultContentGrid.end, children: _jsx(StyledLegalNav, { children: publicLegalDocuments.map(([publicId, legalDocument]) => (_jsx(LegalNavItem, { to: `/${publicId}`, children: legalDocument.title }, publicId))) }) }) }), _jsx(Grid, { children: _jsxs(Cell, { start: defaultContentGrid.start, end: defaultContentGrid.end, children: [_jsx(Heading, { level: 1, as: 2, spacer: "x3", children: title }), _jsx(LegalDocumentContent, { content: content, variant: "web" })] }) })] }));
};
export default Legal;
